import actions from "./actions";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { EcareState } from "./types";
import { RootState } from "@/store/types";

const ecare: Module<EcareState, RootState> = {
  // namespaced: true,
  actions,
  mutations,
  state,
};

export default ecare;
